import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessOutlined = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M14.173 6.45h-1.047a.71.71 0 0 0-.578.298L9.04 11.614 7.45 9.408a.714.714 0 0 0-.578-.296H5.825a.18.18 0 0 0-.145.283l2.781 3.857a.71.71 0 0 0 1.154 0l4.701-6.518a.178.178 0 0 0-.143-.283Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.478 10-10S15.522 0 10 0Zm0 18.304A8.305 8.305 0 0 1 1.696 10 8.305 8.305 0 0 1 10 1.696 8.305 8.305 0 0 1 18.304 10 8.305 8.305 0 0 1 10 18.304Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgSuccessOutlined);
export default ForwardRef;
